import React from 'react';
import { GlobalContext } from '../../../utils/globalprovider';

import './icon.css';

class Icon extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);

    this.state = {
      mouseenter: false,
      mousedown: false,
    };

    this.mouseleave = this.mouseleave.bind(this);
    this.mouseenter = this.mouseenter.bind(this);
    this.mousedown = this.mousedown.bind(this);
    this.mouseup = this.mouseup.bind(this);
    this.onImageClick = this.onImageClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  onImageClick() {
    if (this.props.button && this.props.disable) return;
    if (this.props.onClick) this.props.onClick(this.props.datas);
  }

  onKeyDown(event) {
    if (this.props.onKeyDown) this.props.onKeyDown(event);
  }

  mousedown() {
    if (this.props.button && !this.props.disable) {
      this.setState({ mousedown: true });
    }
  }

  mouseup() {
    if (this.props.button && !this.props.disable) {
      this.setState({ mousedown: false });
    }
  }

  mouseenter() {
    if (this.props.button && !this.props.disable) {
      this.setState({ mouseenter: true });
    }
  }
  mouseleave() {
    if (this.props.button && !this.props.disable) {
      this.setState({ mouseenter: false });
    }
  }

  removeFocus() {}
  render() {
    if (this.props.text != null) {
      var classnameover = '.icon-textmousedown';
      if (this.state.mouseenter) classnameover = 'icon-textenter';

      var classnamedown = 'icon-textmouseup';
      if (this.state.mousedown) classnamedown = 'icon-textmousedown';

      var filter = [];

      filter['borderRadius'] = '5px';
      filter['borderWidth'] = '1px';
      filter['paddingTop'] = '-4px';

      //filter["transform"] = "scaleX(0.7)";  /* Compress the text horizontally */

      if (this.props.border) {
        filter['borderStyle'] = 'solid';
        filter['borderSize'] = '1px';
      }
      filter['boxSizing'] = 'border-box';
      filter['MozBoxSizing'] = 'border-box';
      filter['WebkitBoxSizing'] = 'border-box';
      //filter["display"] = "inline-block";

      filter['fontSize'] = (this.props.height - 2).toString() + 'px';
      filter['paddingBottom'] = '3px';
      if (this.props.disable) {
        filter['color'] = 'var(--default-disable-icon-color)';
        filter['borderColor'] = 'var(--default-diable-icon-color)';
      } else {
        filter['color'] = 'var(--default-icon-color)';
        filter['borderColor'] = 'var(--default-icon-color)';
      }

      return (
        <span
          className={classnamedown + ' ' + classnameover}
          alt={this.props.alt ?? ''}
          onMouseDown={this.mousedown}
          onMouseUp={this.mouseup}
          onMouseEnter={this.mouseenter}
          onMouseLeave={this.mouseleave}
          onClick={this.onImageClick}
          style={filter}
          onKeyDown={this.onKeyDown}
        >
          &nbsp;&nbsp;
          {this.context.language === 'fr'
            ? this.props.text.fr
            : this.props.text.en}
          &nbsp;&nbsp;
        </span>
      );
    }

    this.filter = [];
    if (!this.props.disable && !this.props.nochangecolor)
      this.filter = { filter: localStorage.getItem('default-icon-filter') };
    else {
      if (this.props.disable)
        this.filter = {
          filter: localStorage.getItem('default-icon-filter-disabled'),
        };
    }

    if (this.props.bordertoolbar) {
      this.filter['borderRadius'] = '5px';
      this.filter['borderWidth'] = '1px';
      this.filter['borderColor'] = 'red';
      this.filter['borderStyle'] = 'solid';
      this.filter['boxSizing'] = 'border-box';
      this.filter['MozBoxSizing'] = 'border-box';
      this.filter['WebkitBoxSizing'] = 'border-box';
    }

    if (this.props.border) {
      this.filter['borderRadius'] = '5px';
      this.filter['borderWidth'] = '2px';
      this.filter['borderColor'] = 'var(--default-icon-color)';
      this.filter['borderStyle'] = 'solid';
      this.filter['boxSizing'] = 'border-box';
      this.filter['MozBoxSizing'] = 'border-box';
      this.filter['WebkitBoxSizing'] = 'border-box';
    }

    var classnameover = 'icon-mouseleave';
    if (this.state.mouseenter) classnameover = 'icon-mouseenter';

    var classnamedown = 'icon-mouseup';
    if (this.state.mousedown) classnamedown = 'icon-mousedown';

    if ('inverseColor' in this.props) {
      return (
        <div
          style={{
            backgroundColor: this.props.inverseColor
              ? '#202020'
              : 'transparent',
            borderRadius: '5px',
            borderStyle: this.props.inverseColor ? 'solid' : 'none',
            borderColor: 'gray',

            borderWidth: '1px',
            paddingRight: '3px',
            paddingLeft: '3px',
            paddingTop: '3px',
          }}
        >
          <img
            className={classnamedown + ' ' + classnameover}
            onMouseDown={this.mousedown}
            onMouseUp={this.mouseup}
            onMouseEnter={this.mouseenter}
            onMouseLeave={this.mouseleave}
            src={this.props.image}
            style={this.filter}
            width={this.props.width}
            height={this.props.height}
            onClick={this.onImageClick}
            onKeyDown={this.onKeyDown}
            alt={this.props.alt ?? ''}
          />
        </div>
      );
    }
    return (
      <img
        className={classnamedown + ' ' + classnameover}
        onMouseDown={this.mousedown}
        onMouseUp={this.mouseup}
        onMouseEnter={this.mouseenter}
        onMouseLeave={this.mouseleave}
        src={this.props.image}
        style={this.filter}
        width={this.props.width}
        height={this.props.height}
        onClick={this.onImageClick}
        onKeyDown={this.onKeyDown}
        alt={this.props.alt ?? ''}
      />
    );
  }
}
Icon.defaultProps = {
  width: 64,
  height: 64,
  border: false,
  disable: false,
  button: false,
  text: null,
};

export default Icon;
